<template>
  <menubar />
  <div class="container">
    <!-- タイトルdivタグ -->
    <div id="title" class="d-flex justify-content-start">
      <img src="/img/05_slash.svg" />
      <p class="h1">お問い合わせ</p>
    </div>
    <div class="contact-form">
        <dl>
          <div>
            <dt><span class="required">お名前</span></dt>
            <dd><input v-model="entryName" type="text" name="name" class="name" required /></dd>
          </div>
          <div>
            <dt><span class="required">メールアドレス</span></dt>
            <dd><input  v-model="entryEmail" type="email" name="email" class="email" required /></dd>
          </div>
          <div>
            <dt><span class="required">電話番号</span></dt>
            <dd><input  v-model="entryTel" type="tel" name="tel" class="tel" /></dd>
          </div>
          <div>
            <dt><span class="required">ご希望のご連絡方法</span></dt>
            <dd>
              <input type="radio" name="contact" value="email"  v-model="entryWay" />Eメール
              <input type="radio" name="contact" value="phone" v-model="entryWay" />電話
            </dd>
          </div>
          <div>
            <dt><span class="required">お問い合わせ内容</span></dt>
            <dd>
              <textarea name="message" class="message" v-model="entryContents"></textarea>
            </dd>
          </div>
          <div>
            <dt></dt>
            <dd>
              <button type="submit" class="btn btn-purple" @click="submitInquiry">送信</button>
            </dd>
          </div>
          <div class="attention">
            <dt></dt>
            <dd>
              <p>
                ※「<span class="required"></span>」の付いている項目は必須項目です。<br>
                ※メッセージ送信後、48時間以内に担当者よりご連絡いたします。
              </p>
            </dd>
          </div>
        </dl>
    </div>
  </div>
  <footerComponent />
</template>


<script>
import { defineComponent, reactive } from 'vue';
import { Inertia } from '@inertiajs/inertia'
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";
// import axios from 'axios';

export default defineComponent({
  components: { menubar, footerComponent },
    data() {
      return {
        entryName: "",
        entryEmail: "",
        entryTel: "",
        entryType: "3", // その他問い合わせ
        entryWay: "",
        entryContents: "",
      };
  },
  props: {
    csrf_token: String,
  },
  methods:
  {
    submitInquiry() {
        const inquiry = {
          name: this.entryName,
          email: this.entryEmail,
          phone_number: this.entryTel,
          inquiry_type_id: this.entryType,
          contract_method: this.entryWay,
          text: this.entryContents,
        };

        axios.post('/inquiries', inquiry ,{
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-CSRF-TOKEN": this.csrf_token,
            },
          })
          .then((response) => {
            if (response.status === 204) {
              alert('お問い合わせを受け付けました');
              location.reload();
            }
            else {
              alert('お問い合わせの送信に失敗しました。\nもう一度お願いします');
              location.reload();
            }
          });
    },

  }
});
</script>


<style lang="scss" scoped>
#title {
  margin: 3rem 0;
  img {
    width: 3rem;
    height: 3rem;
  }
  p {
    color: #666666;
  }
}
.container {
  min-height: 80vh;
}
.contact-form {
  background-color: #FFFBF9;
  padding-left: 2rem;
  color: #666666;
  dl {
    dt {
    width: 15%;
    padding: 0.6rem 0;
    margin-right: 2rem;
    float: left;
    clear: both;
    }
    dd {
      padding: 0.6rem 0;
    }
  }
  .name {
    width: 30%;
    height: 2rem;
  }
  .email {
  width: 40%;
  height: 2rem;
  }
  .tel {
    width: 30%;
    height: 2rem;
  }
  .type {
    width: 25%;
    height: 2rem;
  }
  .message {
    width: 60%;
    height: 10rem;
  }
  .attention {
  dt {
    height: 3rem;
  }
  }
  .required{
    &:after {
      content: "*";
      padding-left: 0.2rem;
      color: #ff0000;
    }
  }
}
</style>